/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorParagraph from 'sites/allas/components/labrador/Paragraph';

export const DynamicLabradorParagraph: typeof LabradorParagraph = (props) => {
    return <ErrorBoundary><LabradorParagraph {...props} /></ErrorBoundary>;
}
export type DynamicLabradorParagraphProps = PropsFromComponent<typeof LabradorParagraph>;
